import { Grid2 as Grid } from '@mui/material'
import { SingleECGLeadGraph } from './SingleECGLeadGraph'

interface ECGLeadRowProps {
  leads: {
    name: string
    data: number[]
    highlight: boolean
    onClick: () => void
    isRhythmStrip?: boolean
  }[]
  height?: number
}

/**
 * Componente que renderiza uma linha de derivações de ECG
 * Cada linha contém 4 derivações (exceto a linha do ritmo)
 */
export const ECGLeadRow = ({ leads, height = 100 }: ECGLeadRowProps) => {
  const gridSize = leads.length === 1 ? 12 : 3

  return (
    <Grid container spacing={0}>
      {leads.map(lead => (
        <Grid key={lead.name} size={gridSize}>
          <SingleECGLeadGraph
            leadName={lead.name}
            data={lead.data}
            height={height}
            highlight={lead.highlight}
            isRhythmStrip={lead.isRhythmStrip}
            onClick={lead.onClick}
          />
        </Grid>
      ))}
    </Grid>
  )
}
